import { useEffect, useState } from 'react';

/**
 * Bumps when customer logs in/out or tier changes (nls-auth-changed).
 * Use in product listing useEffect deps to refetch tier-adjusted prices.
 */
export function usePricingRefresh(): number {
  const [token, setToken] = useState(0);

  useEffect(() => {
    const bump = () => setToken((t) => t + 1);
    window.addEventListener('nls-auth-changed', bump);
    return () => window.removeEventListener('nls-auth-changed', bump);
  }, []);

  return token;
}
